<template>
    <h1 class="text-2xl text-gray-900">
        <slot />
    </h1>
</template>